// AF-3.16 — LearningCard.
//
// Separates AF-2.8 (entity-scoped, general) and AF-3.8 (decision-scoped,
// creator) learnings by an explicit `source` label -- these are never
// collapsed into one undifferentiated conclusion (spec Section 20).
// Conflicting learnings are shown with a first-class CONFLICTING badge,
// never resolved by majority vote in the UI.

import { StatusBadge, ConfidenceIndicator } from "./Badges";

export function LearningCard({ learning, source, conflicting = false, testId = "learning-card" }) {
  if (!learning) return null;
  return (
    <div data-testid={testId} className="rounded-[var(--radius-card)] border border-[var(--border)] bg-[var(--surface)] p-4 shadow-[var(--shadow-card)]">
      <div className="flex items-start justify-between gap-2 mb-2">
        <span className="text-[9px] font-mono uppercase text-[var(--text-tertiary)] border border-[var(--border)] rounded px-1.5 py-0.5" data-testid="learning-source">
          {source === "creator" ? "Creator learning (AF-3.8)" : "Operational learning (AF-2.8)"}
        </span>
        {conflicting && <StatusBadge value="CONFLICTING" />}
      </div>
      <p className="text-[12px] text-[var(--text-primary)] mb-2">{learning.statement}</p>
      <div className="flex items-center gap-3 flex-wrap text-[10px]">
        {learning.metric_key && <span className="text-[var(--text-secondary)]">Metric: <span className="text-[var(--text-primary)] font-mono">{learning.metric_key}</span></span>}
        {learning.status && <StatusBadge value={learning.status} />}
        {learning.confidence !== undefined && learning.confidence !== null && (
          <div className="flex items-center gap-1"><span className="text-[var(--text-secondary)]">Confidence:</span><ConfidenceIndicator value={learning.confidence} /></div>
        )}
      </div>
    </div>
  );
}

export function LearningConflictNotice({ count }) {
  if (!count) return null;
  return (
    <div data-testid="learning-conflict-notice" className="px-3 py-2 rounded-md border border-[var(--warning-border)] bg-[var(--warning-bg)] mb-3">
      <p className="text-[11px] text-[var(--warning)]">
        {count} conflicting learning{count > 1 ? "s" : ""} on the same metric. Martian preserves both sides of the evidence rather than resolving the conflict by majority vote.
      </p>
    </div>
  );
}
